// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"795cf407","154":"3859abcc","408":"41caec9c","760":"c763c6b0"}[chunkId] + ".chunk.js";
};